import { render, staticRenderFns } from "./file-upload.vue?vue&type=template&id=12032941&scoped=true&"
import script from "./file-upload.vue?vue&type=script&lang=js&"
export * from "./file-upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12032941",
  null
  
)

export default component.exports